
import { Component, PropSync, Vue, Watch } from 'vue-property-decorator'
import Expenditure from "@/types/expenditure/expenditure"
import ExpenditureList from "@/components/Expenditure/ExpenditureList.vue"
import ConfirmDialog from "@/components/ConfirmDialog.vue"

@Component({
  components: {
    ExpenditureList,
    ConfirmDialog
  }
})
export default class ExpenditureDialog extends Vue {
  @PropSync('dialog', { type: Boolean }) expenditureDialog!: boolean;
  @PropSync('trackingId', { type: String }) currentTrackingId!: string;
  private quantity = 1
  private valid = false
  private updateProcess = false
  private position: string | null = null
  private positionPrice: number | null = null
  private totalPrice: number | null = null
  private confirmDeleteDialog = false
  private expenditureToUpdate: Expenditure | null = null

  private notEmptyRule = [
    (v: any) => !!v || this.$t('global.required')
  ]

  @Watch('positionPrice')
  private positionPriceChanged () {
    if (!this.positionPrice) return
    this.totalPrice = this.positionPrice * this.quantity
  }

  @Watch('quantity')
  private quantityChanged () {
    if (!this.positionPrice) return
    this.totalPrice = this.positionPrice * this.quantity
  }

  @Watch('totalPrice')
  private totalPriceChanged () {
    if (!this.totalPrice) return
    this.positionPrice = this.totalPrice / this.quantity
  }

  private get expenditureData () {
    const expenditure = new Expenditure()
    expenditure.quantity = this.quantity
    expenditure.position = this.position
    expenditure.positionPrice = this.positionPrice
    expenditure.totalPrice = this.totalPrice
    this.resetDialog()
    this.$root.$emit('fetchExpenditures')
    return expenditure
  }

  private resetDialog () {
    const refForm: any = this.$refs.form
    refForm.reset()
  }

  private handleExpenditureClicked (expenditure: Expenditure) {
    this.updateProcess = true
    this.expenditureToUpdate = expenditure
    this.quantity = Number(expenditure.quantity)
    this.position = expenditure.position
    this.positionPrice = Number(expenditure.positionPrice)
    this.totalPrice = Number(expenditure.totalPrice)
  }

  private handleSaveButtonClicked () {
    if (this.updateProcess && this.expenditureToUpdate) {
      this.expenditureToUpdate.quantity = this.quantity
      this.expenditureToUpdate.position = this.position
      this.expenditureToUpdate.totalPrice = this.totalPrice
      this.expenditureToUpdate.positionPrice = this.positionPrice
      this.$emit('update', this.expenditureToUpdate)
      this.resetDialog()
      this.updateProcess = false
      this.expenditureToUpdate = null
      this.$root.$emit('fetchExpenditures')
    } else {
      this.$emit('save', this.expenditureData)
    }
  }

  private handleDeleteButtonClicked () {
    if (this.expenditureToUpdate) {
      this.$emit('delete', this.expenditureToUpdate)
      this.resetDialog()
      this.confirmDeleteDialog = false
      this.updateProcess = false
      this.expenditureToUpdate = null
      this.$root.$emit('fetchExpenditures')
    }
  }

  private handleCancelClicked () {
    this.resetDialog()
    this.updateProcess = false
    this.expenditureToUpdate = null
    this.$root.$emit('fetchExpenditures')
  }
}
